<template>
  <div class="home">
    <b-container fluid id="home-content">
      <b-row>
        <!-- ORDERS LIST -->
        <b-col cols="3">
          <OrderList @orderChanged="updateOrder"></OrderList>
        </b-col>

        <!-- ITEM PICKER -->
        <b-col cols="9">
          <PickList
            v-if="selectedOrder.id"
            v-bind:order="selectedOrder"
          ></PickList>
          <div v-else>
            <h4>Select an Order</h4>
            <div>
              <b-nav align="right">
                <b-button
                  @click="$router.push('/settings')"
                  class="primary mb-2"
                  >Settings</b-button
                >
              </b-nav>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import OrderList from "@/components/OrderList.vue";
import PickList from "@/components/PickList.vue";

export default {
  name: "Home",
  components: {
    OrderList,
    PickList,
  },
  data() {
    return {
      barcode: "",
      selectedOrder: {},
    };
  },
  methods: {
    updateOrder(order) {
      this.selectedOrder = order;
    },
  },
  computed: {},
};
</script>

<style lang="scss">
#home-content {
  padding: 0 45px;
}
</style>

